import React, { useState, useEffect } from 'react';
import { Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { useQuestionStore } from 'lowcomp/plugins/member/member-questions/content/components/QuestionProvider';
import styled from './index.module.scss';
import NextImage from '@/components/NextImage';
import type { IOptionItem } from '@/components/AppreciationDay/index.d';

interface IRadioComponentProps {
    opstions: IOptionItem[];
    isMobile: boolean;
    onChange?: (val: string) => void;
}

const RadioComponent: React.FC<IRadioComponentProps> = ({ opstions, onChange }) => {
    const { question, index } = useQuestionStore();
    const { userAnswer, defAnswer } = question[index];
    const [radioValue, setRadioValue] = useState<string>(userAnswer || '');
    useEffect(() => {
        setRadioValue(userAnswer || '');
    }, [userAnswer]);

    const onRadioChange = (e: RadioChangeEvent) => {
        if (defAnswer) return;
        setRadioValue(e.target.value);
        onChange && onChange(e.target.value);
    };

    const getClassName = (optionId: string) => {
        if (!defAnswer) return '';
        if (optionId !== defAnswer) return 'error';
        return 'success';
    };

    return (
        <div className={styled.radio}>
            <Radio.Group onChange={onRadioChange} value={radioValue}>
                {opstions &&
                    opstions.map((item, index) => (
                        <div className="radio-item-wrap" key={`${item.optionId}${index}`}>
                            <Radio value={item.optionId} className={getClassName(item.optionId)}>
                                {item.optionUrl && (
                                    <div className="radio-item-img">
                                        <NextImage src={item.optionUrl} alt={item.optionName} aria-label={item.optionName} />
                                    </div>
                                )}
                                {item.optionSelect}.{item.optionName}
                            </Radio>
                        </div>
                    ))}
            </Radio.Group>
        </div>
    );
};

export default RadioComponent;
